import Panzoom from "@panzoom/panzoom";

export function floorplan(activeFloor) {
  return {
    activeFloor: activeFloor,

    init() {
      const stageEl = this.$refs.stage || null;

      if(!stageEl) {
        console.log('stage not found');
        return;
      }

      const maxScale = 3;

      const panzoom = Panzoom(stageEl, {
        maxScale: maxScale,
        contain: 'outside'
      });

      const zoomInBtn = this.$refs.zoomIn || null;
      const zoomOutBtn = this.$refs.zoomOut || null;

      function disableButtons() {
        var scale = panzoom.getScale();

        if ( scale >= maxScale ) {
          zoomInBtn.disabled = true;
        } else {
          zoomInBtn.disabled = false;
        }

        if ( scale <= 1.01 ) {
          zoomOutBtn.disabled = true;
        } else {
          zoomOutBtn.disabled = false;
        }
      }

      // Panning and pinch zooming are bound automatically (unless disablePan is true).
      // Custom Controls
      function adjustScale(zoomIn) {
        if (zoomIn) {
          panzoom.zoomIn();
        } else {
          panzoom.zoomOut();
        }
      }

      if (!zoomInBtn || !zoomOutBtn) {
        console.log('zoom buttons not found');
      } else {
        zoomInBtn.addEventListener('click', () => adjustScale(true))
        zoomOutBtn.addEventListener('click', () => adjustScale(false));
      }

      stageEl.addEventListener('panzoomchange', () => disableButtons());

      // Mouse wheel
      stageEl.parentElement.addEventListener('wheel', panzoom.zoomWithWheel);

      // Reset
      this.$watch('activeFloor', () => panzoom.reset());

      // Ready
      disableButtons();
    }
  };
}
